import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeBucketName: "", // name of the currently selected bucket in Operations Tracker
};

const processGuideSlice = createSlice({
  name: "processGuide",
  initialState,
  reducers: {
    setActiveBucketName: (state, action) => {
      state.activeBucketName = action.payload || "";
    },
    clearActiveBucketName: (state) => {
      state.activeBucketName = "";
    },
  },
});

export const { setActiveBucketName, clearActiveBucketName } = processGuideSlice.actions;
export default processGuideSlice.reducer;


